import React, { useEffect, useState } from 'react';
import '../../../styles/scss/template-editor.scss'
import Button from 'devextreme-react/button'
//import FileUploader from 'devextreme-react/file-uploader';

const TemplateEditor = (props) => {
    const { template, setGetTemplateData } = { ...props }

    const [selectedFiles, setSelectedFiles] = useState([])
    const [fileType, setFileType] = useState(null)
    const [editableContent, setEditableContent] = useState()
    const [showSource, setShowSource] = useState(false)
    const [isSaved, setIsSaved] = useState(false);


    useEffect(() => {
        onTemplateLoad(template)   //initial state updates withchoosen file/template
    }, [])


    useEffect(() => {
        setGetTemplateData(editableContent)  //call back to Scheduler with Template Data
    }, [editableContent])

    const onTemplateLoad = file => {
        let type = file.type
        let val;
        if (type.indexOf('htm') > -1)
            val = 'htm'
        setFileType(val)
        setSelectedFiles(file);
        generateEditableContent(file);
    }

    //Genrate Editable content and ediatbleContent state
    const generateEditableContent = file => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.addEventListener('load', e => {
            const data = e.target.result;
            setEditableContent(data)
        });
    }


    // toggle source and content div and saving changes
    const handleShowSource = () => {
        handleSaveChanges()
        setShowSource(prev => !prev)
    }

    //saving changes
    const handleSaveChanges = () => {
        if (!showSource) {
            updateEditableContent("editable_content")
        } else {
            updateEditableContent("editable_source")
        }
        setIsSaved(true)
    }

    // Updating EditableContent state with editable div contents
    const updateEditableContent = (divId) => {
        let updatedContent = editableContent;
        if (divId === "editable_content") {
            updatedContent = document.getElementById(divId).innerHTML.trim();
        }
        else {
            updatedContent = document.getElementById(divId).innerText.trim();
        }
        setEditableContent(updatedContent)
    }

    //reevrting back to original content data
    const handleOriginalContent = () => {
        onTemplateLoad(template)
        setIsSaved(false)
    }


    //const onFileSelect = e => {
    //    setSelectedFiles([])
    //    let type = e.value[0].type
    //    let val;
    //    if (type.indexOf('htm') > -1)
    //        val = 'htm'
    //    setFileType(val)
    //    setSelectedFiles(e.value);
    //    generateEditableContent(e);
    //}

    return (
        <div style={{ display: "flex", justifyContent: "space-between", gap: "2rem" }}>
            <div style={{ width: "100%", height: "100%" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    {/*<FileUploader className="" selectButtonText="Choose a Template" labelText="Max. File Size 4 MB" accept="*" uploadMode="useForm" onValueChanged={onFileSelect} value={selectedFiles} allowedFileExtensions={['.html', '.htm']} /> */}
                    <div>
                        <Button text="Show Content" onClick={handleShowSource} disabled={!showSource} style={{ maxHeight: "50px" }} />
                        <Button text="Show Source" onClick={handleShowSource} disabled={showSource} style={{ maxHeight: "50px" }} />
                    </div>
                    <div>
                        <Button onClick={handleOriginalContent} text="" icon="revert" />
                        <Button
                            disabled={isSaved}
                            onClick={handleSaveChanges} text={isSaved ? "Saved" : "Save"}
                            icon={isSaved ? "check" : ""} type={isSaved ? "" : "success"}
                        />
                    </div>
                </div>

                {!showSource
                    ?
                    <div
                        id="editable_content"
                        dangerouslySetInnerHTML={{ __html: editableContent ? editableContent : "Select Template" }}
                        contentEditable="true"
                        style={{
                            width: "100%", height: "100%",
                            border: "1px solid gray", padding: "1rem", overflow: "auto"
                        }}
                    >

                    </div>
                    :
                    <div style={{ width: "100%", border: "1px solid gray", padding: "1rem", overflow: "auto" }}>
                        <pre
                            id="editable_source"
                            contentEditable="true"
                            style={{ overflowX: "auto", whiteSpace: "pre-wrap", wordWrap: 'break-word', tabSize: 4 }}
                        >
                            {editableContent}
                        </pre>
                    </div>
                }

            </div>
        </div>
    )
}

export default TemplateEditor